// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("./../../../node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-kosarica-js": () => import("./../../../src/pages/kosarica.js" /* webpackChunkName: "component---src-pages-kosarica-js" */),
  "component---src-pages-najava-servis-js": () => import("./../../../src/pages/najava-servis.js" /* webpackChunkName: "component---src-pages-najava-servis-js" */),
  "component---src-pages-nalog-js": () => import("./../../../src/pages/nalog.js" /* webpackChunkName: "component---src-pages-nalog-js" */),
  "component---src-templates-page-js": () => import("./../../../src/templates/page.js" /* webpackChunkName: "component---src-templates-page-js" */)
}

